/*
 * File: c:\Users\j.mazat\Desktop\Autofi\autofi_backoffice\src\Content\Car\CarList\CarList.tsx
 * Project: c:\Users\j.mazat\Desktop\Autofi\autofi_backoffice
 * Created Date: Monday March 25th 2024
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Monday March 25th 2024 2:48:22 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2024 Autobuy SAS
 * -----
 */

import { useEffect, useMemo, useRef, useState } from "react";
import { useLoaderData, useNavigate } from "react-router-dom";
import RouterPathResolver from "Config/Router/RouterPathResolver";
import translator from "MultiLanguage/TranslationWrapper";
// import { PartnerType } from "Type/partner.type";
import CarCard from "Content/CarCard/CarCard";
import CarService from "Services/Car/CarService";
import ModalConfirmation from "Content/Modals/ModalConfirmation/ModalConfirmation";
import LoadingScreen from "Content/LoadingScreen/LoadingScreen";
import { useIntersectionObserver } from 'react-intersection-observer-hook';
import SeenCarComponent from "Content/SeenCar/SeenCarComponent";
import CollapseBox from "Content/CollapseBox/CollapseBox";
import SearchByTerm from "Content/Search/SearchByTerm";
import { CarListType, CarType } from "Type/Car.type";
import SeenCarService from "Services/SeenCar/SeenCar.service";

function CarList(_: any) {
    const navigate = useNavigate();
    const loadData: CarListType = useLoaderData() as CarListType;
    const [showModal, setShowModal] = useState(false);
    const [spinner, setSpinner] = useState(false);
    const [isOkay, setIsOkay] = useState(false);
    const [views, setViews] = useState(0);
    const [myCars, setMyCars] = useState<any[]>(loadData.cars);
    // const [countCar, setCountCar] = useState(0);
    // const [ref, { entry }] = useIntersectionObserver();
    // const isVisible = entry && entry.isIntersecting;
    // const firstLoad = useRef(true);
    // const [result, setResult] = useState<{label: String, result: any}[]>([]);

    useEffect(() => {
        SeenCarService.totalViews().then((result) => {
            setViews(result.data);
        }).catch(() => {
            setViews(0);
        });
    }, []);

    // useEffect(() => {
    //     if (result.length > 0) {
    //         setMyCars(result.map(v => v.result));
    //         // setCountCar(result.length);
    //     } else {
    //         setMyCars(loadData.cars);
    //         // setCountCar(0);
    //     }
    // }, [result]);

    // const visible = useMemo(() => {
    //     new Promise(r => setTimeout(r, 500)).then(() => {
    //         if (!firstLoad.current && isVisible !== undefined && isVisible == true && carRows.length > 0)
    //             handleLoadMoreCar();
    //         else
    //             firstLoad.current = false;
    //     });
    // }, [isVisible]);

    // const selectOnlyPartners = (Packs: Pack[]) => {
    //     const partners: PartnerType[] = [];
    //     for (const pack of Packs) {
    //         for (const packPartner of pack.PackPartner) {
    //             if (!(partners.map(val => val.id).includes(packPartner.Partner.id)))
    //                 partners.push(packPartner.Partner);
    //         }
    //     }
    //     return partners;
    // };

    // const buildHeaderInfo = (data: SellSingle) => {
    //     return {
    //         nbCar: data.sell.nbCar,
    //         sellID: data.sell.id,
    //         Name: data.sell.Name,
    //         EndDate: data.sell.EndDate,
    //         StartDate: data.sell.StartDate,
    //         Picture: data.sell.Picture,
    //         Status: data.sell.Status,
    //         PartnerPicture: data.sell.PartnerPicture,
    //         Advertise: data.sell.Advertise,
    //         AdvertisedPicture: data.sell.AdvertisedPicture,
    //         Exclusive: data.sell.Exclusive,
    //         HideLinks: data.sell.HideLinks,
    //         HideCost: data.sell.HideCost,
    //         Partners: selectOnlyPartners(data.sell.Packs),
    //         SellGroups: data.sell.SellGroup,
    //         ExcludedSellGroups: data.sell.SellExcludedGroup,
    //         Editable: data.editable,
    //         SellType: data.sell.SellType.Name,
    //         nbOffer: data.sell.nbOffer,
    //         nbView: data.sell.nbView
    //     };
    // };

    // const [edit, setEdit] = useState(buildHeaderInfo(loadData).Editable  ?? false);

    function handleChangeState(isOk: boolean, openModal: boolean, spin: boolean) {
        setIsOkay(isOk);
        setShowModal(openModal);
        setSpinner(spin);
    };

    const handleClickCar = (id: string, editable: boolean) => {
        navigate(`${RouterPathResolver.pathCar_BY_ID.path.replace(":id", id)}`+`${editable ? "?editable=true" : ""}`);
    };

    const buildMyRows = (Car: CarType[]) => {
        let myRows: JSX.Element[] = [];
        for (let i = 0; i < Car.length; ++i) {
            myRows.push(
                <div key={`sell-${Car[i].RegNb}`} >
                    <CarCard handleNavigation={handleClickCar} car={{...Car[i], SeenCar: Car[i].SeenCar}} />
                </div>
            );
        }
        return myRows;
    };

    // const handleRetrievePictures = (carId: string) => {
    //     setSpinner(true);
    //     CarService.retrievePicturesForCar(carId).then(() => {
    //         handleChangeState(true, true, false);
    //     }).catch(() => {
    //         handleChangeState(false, true, false);
    //     });
    // };

    const carRows = useMemo<JSX.Element[]>(
        () => buildMyRows(myCars),[myCars]
    );

    // const handleLoadMoreCar = () => {
    //     if (isVisible !== true || countCar <= carRows.length)
    //         return;
    //     const url = window.location;
    //     const myParams = InitRequestParams(url.toString());
    //     myParams.page = myParams.page + 1;
    //     ServiceGeneral.manageAxiosResponse( async () => {return SellService.getSingleSell(loadData.sell.id, {...myParams});}, () => null)
    //     .then((res: { Cars: any; }) => {
    //         const searchParams = new URLSearchParams(url.search);
    //         searchParams.set("page", myParams.page.toString());
    //         window.history.replaceState(null, "", `${url.pathname}?${searchParams.toString()}`);
    //         setMyCars([...myCars, ...res.Cars]);
    //     })
    //     .catch((error: any) => {
    //         console.log(error);
    //     });
    // };

    return(
        <div className="d-flex p-3 flex-column justify-content-between">
            {
                spinner ?
                    <div >
                        <LoadingScreen />
                    </div>
                    :null
            }
            {/* <SingleSellHeader {...buildHeaderInfo(loadData)} /> */}
            <CollapseBox class={"mb-3"} textBtn={`${translator.decode("dynamic.views")} ${views}`}>
                <SeenCarComponent showTimeFilter={false}/>
            </CollapseBox>
            {/* <div>
                <SearchByTerm searchFunc={CarService.getCarBySearch} setResult={setResult} title={translator.decode("table.headers.Car")} />
            </div> */}
            <div >
                {carRows}
            </div>
            {/* {
                carRows.length !== countCar ?
                    <Button ref={ref} className="p-2" onClick={handleLoadMoreCar}>{translator.decode("dynamic.moreCar")}</Button>
                : null
            } */}
            <ModalConfirmation show={showModal} onClose={() => setShowModal(false)} closeModal={() => setShowModal(false)} isOkay={isOkay} />
        </div>
    );
}

export default CarList;
